import { Injectable } from '@angular/core';
import { IEntityWithId } from './entityhelper';

export function initialize(module: ng.IModule) {
    module.service(ArrayHelper.Id, ArrayHelper);

    ArrayHelper.$inject = [];
} 

/**
 * Provides class which implements common helper methods for Arrays.
 */
@Injectable()
export class ArrayHelper {

    public static Id: string = "arrayHelper";

    /**
     * Copies the specified 'itemsToCopy' array to the
     * 'toArray'. Only copies those items which are not already present.
     */
    public addItems(itemsToAdd: IEntityWithId[], toArray: IEntityWithId[]): void {
        for (let itemToAdd of itemsToAdd) {
            this.addItem(itemToAdd, toArray);
        }
    }

    public addItem(itemToAdd: IEntityWithId, toArray: IEntityWithId[]): void {
        if (!this.exists(itemToAdd, toArray)) {
            toArray.push(itemToAdd);
        }
    }

    /**
     * Removes items from an Array.
     */
    public removeItems(itemsToRemove: IEntityWithId[], fromArray: IEntityWithId[]): void {
        // Create local copy of the array. This is necessary in cases where, e.g., the
        // same array is passed as both parameters to this method.
        itemsToRemove = itemsToRemove.map(item => item);

        for (let itemToRemove of itemsToRemove) {
            this.removeItem(itemToRemove, fromArray);
        }
    }

    public removeItem(itemToRemove: IEntityWithId, fromArray: IEntityWithId[]): void {
        for (let j = 0; j < fromArray.length; j++) {
            if (fromArray[j].Id === itemToRemove.Id) {
                fromArray.splice(j, 1);
                break;
            }
        }
    }

    private exists(item: IEntityWithId, array: IEntityWithId[]): boolean {
        return array.some(existingItem => existingItem.Id === item.Id);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/array.helper.ts